<button mat-icon-button mat-dialog-close [mat-dialog-close]="false" class="btn close-btn">
  <mat-icon>close</mat-icon>
</button>
<angular-image-viewer *ngIf="type === 'img'" [src]="[url]"></angular-image-viewer>
<video *ngIf="type === 'video'" [src]="url" class="video-player" controls autoplay></video>
<youtube-player *ngIf="type === 'youtube' && youtubeId" class="video-player" [videoId]="youtubeId"></youtube-player>
